export const handleTableKeyNav = (event) => {
  const isArrowUp = event.key === "ArrowUp";
  const isArrowDown = event.key === "ArrowDown";
  if (!isArrowUp && !isArrowDown) return;

  const container = event.currentTarget;
  const rows = Array.from(container.querySelectorAll("[data-row='true']"));
  if (!rows.length) return;

  event.preventDefault();
  const currentIndex = rows.findIndex((row) => row === document.activeElement);
  const nextIndex =
    currentIndex === -1
      ? 0
      : Math.min(
          Math.max(currentIndex + (isArrowDown ? 1 : -1), 0),
          rows.length - 1
        );
  rows[nextIndex].focus();
};
